let timer;
export function debounce(func, milliseconds) {
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(this, args);
    }, milliseconds);
  };
}
